<template>
  <div class="error-page-container">
    <main class="error-page-main">
      <div class="error-headline">
        <h2>
          <span></span
          ><template v-for="(line, i) in normalizedTitleLines" :key="i">
            {{ line }}
            <br v-if="i < normalizedTitleLines.length - 1" />
          </template>
        </h2>
        <p class="error-code">{{ errorCode }}</p>
      </div>
      <div class="error-page-text">
        <div class="config-content">
          <p>
            <template v-for="(line, i) in normalizedLines" :key="i">
              {{ line }}
              <br v-if="i < normalizedLines.length - 1" />
            </template>
          </p>
        </div>
      </div>
      <button class="button-primary" @click="goToLogin">ログイン画面へ戻る</button>
    </main>
  </div>
  <footer>
    <ul>
      <li class="usage-note" id="open-modal" @click="openNotice" style="cursor: pointer">
        ご利用上の注意
      </li>
      <li class="copyright">Copyright &copy; Japan Weather Association. All Rights Reserved.</li>
    </ul>
  </footer>
  <NoticeModal />
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { useErrorStore } from '@/stores/error'
import { useRouter } from 'vue-router'
import { getFieldMessage } from '@/utils/message'
import NoticeModal from '@/components/modal/NoticeModal.vue'

const errorStore = useErrorStore()
const router = useRouter()

const errorCodePattern = /（エラーコード:ERR-(\d+)）/

const errorCode = computed(() => {
  const match = errorStore.title?.match(errorCodePattern)
  return match ? match[0] : ''
})

const errorTitle = computed(() => {
  // エラーコード部分を除去してタイトルだけ返す
  const rawTitle =
    errorStore.title && errorStore.title.length > 0
      ? errorStore.title
      : getFieldMessage('systemerror913_1')
  const title = rawTitle.replace(errorCodePattern, '').trim()
  return title
})

const normalizedTitleLines = computed(() => (errorTitle.value ? errorTitle.value.split('\n') : []))

const errorMessage = computed(() => errorStore.message || getFieldMessage('systemerror913_2'))

const cleanErrorMessage = computed(() => {
  if (!errorMessage.value) return ''
  return errorMessage.value.replace(errorCodePattern, '')
})

const normalizedLines = computed(() =>
  Array.isArray(errorStore.message)
    ? errorStore.message
    : cleanErrorMessage.value
      ? cleanErrorMessage.value.split('\n')
      : [],
)

function goToLogin() {
  router.push({ name: 'Login' })
}

import { useNoticeModalStore } from '@/stores/noticeModal'
const store = useNoticeModalStore()
function openNotice() {
  store.open()
}

// エラー画面用の body クラス付与
onMounted(() => {
  document.body.classList.add('error-page')
  window.addEventListener('popstate', handlePopState)
})

onUnmounted(() => {
  document.body.classList.remove('error-page')
  window.removeEventListener('popstate', handlePopState)
})

function handlePopState() {
  // ブラウザの戻るボタンが押されたときにログイン画面へ遷移
  router.replace({ name: 'Login' })
}
</script>
<style scoped>
footer {
  position: fixed;
  bottom: 0;
}
</style>
